// extracted by mini-css-extract-plugin
export default {"buttonAddCols":"AddColumn_buttonAddCols__Zx+A7","dialog":"AddColumn_dialog__lUPXy","errorText":"AddColumn_errorText__Sn9qN","button":"AddColumn_button__iKcN6"};